import React, { useState, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import axios from "../utils/api";
import { useNavigate } from "react-router-dom";

export default function SignupPage() {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const { setUser } = useContext(AuthContext);
    const navigate = useNavigate();

    async function handleSubmit(e) {
        e.preventDefault();
        try {
            const res = await axios.post("/auth/signup", { username, password });
            setUser(res.data);
            navigate("/");
        } catch (err) {
            setError(err.response?.data?.msg || "Signup failed");
        }
    }

    return (
        <div className="auth-page">
            <form className="auth-form" onSubmit={handleSubmit}>
                <h2>Sign Up</h2>
                <input
                    type="text"
                    placeholder="Username"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                />
                <input
                    type="password"
                    placeholder="Password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                />
                <button type="submit">Sign Up</button>
                {error && <p className="error-msg">{error}</p>}
                <p>Already have an account? <a href="/login">Login</a></p>
            </form>
        </div>
    );
}
